/* eslint-disable react/react-in-jsx-scope */
import { StrictMode } from "react"
import { Switch, Route } from "react-router-dom"

import { createGlobalStyle } from "styled-components"

import { datadogRum } from "@datadog/browser-rum"
import { GlobalOttoStyles } from "@izettle/react"
import { BackOfficeSetup } from "@izettle/react-spa"

import { ScrollToTopOnRouteChange } from "@/components/scroll-to-top"
import { Environment, config, datadogRumConfig } from "@/config"
import { baseUrl } from "@/constants"

import { PageTitleProvider, PageTitle } from "./components/page-title"
import { GenericDocumentUploadView } from "./pages/generic-document-upload"
import { InstructionsView } from "./pages/instructions"
import { LoaView } from "./pages/loa"
import { ProofOfAddressView } from "./pages/proof-of-address"
import { ProofOfIdentityView } from "./pages/proof-of-identity"
import { Purposes } from "./pages/purposes"
import { PurposesProvider } from "./providers/purposes"
import { GlobalStyle } from "./styles/GlobalStyle"

if ([Environment.Staging, Environment.Production].includes(config.appEnv)) {
  datadogRum.init(datadogRumConfig)
}

const GlobalBackOfficeOverrides = createGlobalStyle`
  // Hide the Back Office notification because it nags the user about needing to provide documents while they are already doing that in the Docify MF.
  iz-bo-global-notifications {
    display: none !important;
  }
  // Normalize body padding and margin from backoffice layout
  body {
    margin: 0;
    padding: 0;
  }
`

export const App = () => (
  <StrictMode>
    <BackOfficeSetup
      urls={[]}
      config={config}
      translations={{ projectName: "seller-verification" }}
    >
      <PageTitleProvider>
        <PurposesProvider>
          <ScrollToTopOnRouteChange />
          <GlobalBackOfficeOverrides />
          <GlobalOttoStyles />
          <GlobalStyle />
          <PageTitle />
          <Switch>
            <Route exact path={baseUrl} component={Purposes} />
            <Route exact path={`${baseUrl}/instructions`} component={InstructionsView} />
            <Route path={`${baseUrl}/proofOfAddress`} component={ProofOfAddressView} />
            <Route path={`${baseUrl}/proofOfIdentity`} component={ProofOfIdentityView} />
            <Route
              path={`${baseUrl}/genericDocumentUpload`}
              component={GenericDocumentUploadView}
            />
            <Route path={`${baseUrl}/letterOfAuthorization`} component={LoaView} />
          </Switch>
        </PurposesProvider>
      </PageTitleProvider>
    </BackOfficeSetup>
  </StrictMode>
)
